import { SleepRecorderType } from '@common/validation/customControls/osas/sleepRecorderType';
import { never } from './never';

export function getOsasSleepRecorderText(sleepRecorderType: SleepRecorderType) {
    switch (sleepRecorderType) {
        case SleepRecorderType.recorderWithoutSmartphone:
            return 'WatchPAT 300';
        case SleepRecorderType.recorderWithSmartphone:
            return 'WatchPAT ONE';
        default:
            return never(sleepRecorderType);
    }
}
